<template>
  <v-app id="inspire">    
<!-- ***************************** -->
    <v-card class="overflow-hidden">
      <v-navigation-drawer 
        v-model="drawer" 
        :clipped="$vuetify.breakpoint.lgAndUp" 
        app>
        <v-list dense>
          <template v-for="item in $store.state.sUsuario.menuDtoL">
              <v-list-item :to="item.menu" :key="item.idMenu">
                <v-list-item-action>
                  <v-icon>{{item.icono1}}</v-icon>
                </v-list-item-action>
                <v-list-item-title>
                  {{item.link}}
                </v-list-item-title>
              </v-list-item>
            </template>            
          </v-list>
      </v-navigation-drawer>  
      <v-app-bar 
        :clipped-left="$vuetify.breakpoint.lgAndUp" 
        app color="#b21621" 
        dark 
        shrink-on-scroll
        prominent
        src="../src/assets/Fondo2.jpg"
        fade-img-on-scroll
        scroll-target="#scrolling-techniques-5"
        scroll-threshold="800">
        <v-app-bar-nav-icon 
          @click.stop="drawer = !drawer" />
        <v-toolbar-title
          style="width: 500px"
          class="ml-0 pl-4" >
          <span class="hidden-sm-and-down">Cosmic Contigo</span>
        </v-toolbar-title>
        <v-spacer />
        <v-btn 
          icon
          rounded
          color="white"
          @click="CierraSesion"
          >
          <v-icon>settings_power</v-icon>
        </v-btn>
      </v-app-bar> 

      <v-content>
        <v-container class="fill" fluid pa-0 ma-0>
          <v-slide-y-transition mode="out-in">
            <v-sheet id="scrolling-techniques-5" class="overflow-y-auto" max-height="800" >  
              <v-container style="height: 1500px;">
                <router-view />
                
                <v-snackbar
                  v-model="snackpropiedades.snackbar"
                  :bottom="snackpropiedades.y === 'bottom'"
                  :color="snackpropiedades.color"
                  :left="snackpropiedades.x === 'left'"
                  :multi-line="snackpropiedades.mode === 'multi-line'"
                  :right="snackpropiedades.x === 'right'"
                  :timeout="snackpropiedades.timeout"
                  :top="snackpropiedades.y === 'top'"
                  :vertical="snackpropiedades.mode === 'vertical'"
                >
                  {{ snackpropiedades.text }}
                  <v-btn
                    dark
                    text
                    @click="snackpropiedades.snackbar = false"
                  >
                    Close
                  </v-btn>
                </v-snackbar>

                <v-dialog 
                  v-model="$store.state.sIsBusy" 
                  persistent max-width="490">
                  <template v-slot:activator="{ on }">
                    <v-btn color="primary" dark v-on="on" v-show="false">
                      Open Dialog
                    </v-btn>
                  </template>
                  <v-card>
                    <v-card-title class="headline">
                      Procesando...</v-card-title>
                    <v-card-text>
                      <v-progress-linear
                        color="teal"
                        buffer-value="0"
                        value="20"
                        stream
                      ></v-progress-linear>
                    </v-card-text>
                  </v-card>
                </v-dialog>

              </v-container>
            </v-sheet>
          </v-slide-y-transition>
        </v-container>
      </v-content>

      <v-footer class="font-weight-medium" dark padless app>
        <v-card-text class="py-2 white--text text-center">
            {{ new Date().getFullYear() }} — <strong>Cosmic - Desarrollo</strong>
          </v-card-text>
      </v-footer> 
    </v-card>
  </v-app>
</template>

<script>

export default {
  name: 'App',
  data: () => ({
      drawer: null,
      items: [
        { icon: 'mdi-home', text: 'Inicio', link: '/home' },
        {
          icon: 'mdi-chevron-up',
          'icon-alt': 'mdi-chevron-down',
          text: 'Almacén',
          model: true,
          children: [
            { icon: 'table_chart', text: 'Categorias', link: '/Categoria' },
          ],
        },
        {
          icon: 'mdi-chevron-up',
          'icon-alt': 'mdi-chevron-down',
          text: 'Compras',
          model: false,
          children: [
            { icon: 'table_chart', text: 'Ingresos' },
            { text: 'Proveedores' },
            { text: 'Print' },
            { text: 'Undo changes' },
            { text: 'Other contacts' },
          ],
        },
        {
          icon: 'mdi-chevron-up',
          'icon-alt': 'mdi-chevron-down',
          text: 'Ventas',
          model: false,
          children: [
            { icon: 'table_chart', text: 'Ventas' },
            { text: 'Clientes' },
          ],
        },
        {
          icon: 'mdi-chevron-up',
          'icon-alt': 'mdi-chevron-down',
          text: 'Accesos',
          model: false,
          children: [
            { icon: 'table_chart', text: 'Roles' },
            { text: 'Usuarios' },
          ],
        },
        {
          icon: 'mdi-chevron-up',
          'icon-alt': 'mdi-chevron-down',
          text: 'Consultas',
          model: false,
          children: [
            { icon: 'table_chart', text: 'Compras' },
            { text: 'Ventas' },
          ],
        },
        { icon: 'mdi-settings', text: 'Settings' },
      ],
      snackpropiedades: {
        color: 'success',
        mode: 'vertical',
        snackbar: false,
        text: 'Hello, I\'m a snackbar',
        timeout: 6000,
        x: 'left',
        y: 'bottom'
      },
      ocupado: false
  }),
  mounted() {
    this.Default()
  },
  methods:{
    Default () {
      this.snackpropiedades = this.$Snack
      this.ocupado = this.$esBusy
      //console.log(this.snackpropiedades)
      if(this.$store.state.sIsLogin) {
        console.log('SETEO MENU ')
        // this.menus = this.$store.state.sUsuario.menuDtoL
      }
    },
    CierraSesion () {
      window.location.href = this.$uriUsuarios
    }
  }
};
</script>
